<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <index />
    <!-- <policyquote /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import index from "@/components/index.vue";
//import policyquote from "@/views/policy-quote.vue";

export default {
  name: 'Home',
  components: {
    index
    //policyquote
  }
}
</script>
